import React from 'react';
import logo from '../../assets/Logo_nA.svg';
import './Navbar.css';
import { Link } from 'react-scroll';

const Navbar = () => {
  return (
    <div className="navbar">
      <Link to="header" smooth={true} duration={1000}>
        <img className="logo" src={logo} alt="logo" />
      </Link>
      <div className="navegation">
        <ul className="navegation-list">
          <li>
            <Link to="about-me" smooth={true} duration={1000}>
              About Me
            </Link>
          </li>
          <li>
            <Link to="skills" smooth={true} duration={1000}>
              Skills
            </Link>
          </li>
          <li>
            <Link to="projects" smooth={true} duration={1000}>
              Projects
            </Link>
          </li>
          <Link to="contact" smooth={true} duration={1000}>
            <li>Contact</li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
